import React from "react";
import { useVideoStore } from "./store/use-videos-store";
import { Grid, Paper } from "@mui/material";
import { COLOR_PRIMARY, NAVBAR_HEIGHT_SUM } from "../../../../libs/constants";
import {
  Alert,
  Button,
  Input,
  message,
  Popconfirm,
  Segmented,
  Typography,
} from "antd";
import {
  ClearOutlined,
  PlaySquareOutlined,
  SaveOutlined,
  VideoCameraAddOutlined,
} from "@ant-design/icons";
import { VideoPlayerModal, VideoRecorderNative, VideoPageLayout } from "../../../../libs/shared";
import { workflowContainerVideosPost } from "../../../../libs/apis";
import Swal from "sweetalert2";
import { useOpen } from "../../../../libs/hooks";
import { removeImageBlob, getImageBlob } from "../../../../libs/helpers";
import SweetAlert from "sweetalert2";
import VideoVacio from "./video-vacio";

const { Text } = Typography;

const VideoPageComponent = () => {
  const container = useVideoStore((state) => state.container);
  const setContainer = useVideoStore((state) => state.setContainer);

  return (
    <VideoPageLayout
      title="Video Contenedor Vacío"
      subtitle="Carga del video del contenedor vacío"
      container={container}
      onContainerChange={setContainer}
      selectContent={<VideoVacio />}
      recordContent={<VideoVacioRecorder />}
    />
  );
};

const VideoVacioRecorder = () => {
  const container = useVideoStore((state) => state.container);
  const [loading, setLoading] = React.useState(false); // Maneja el estado de carga
  const [emptyInternalVideo, setEmptyInternalVideo] = React.useState("");
  const [showModal, setShowModal] = React.useState(false);
  const [continuoModal, setContinuoModal] = React.useState(false);
  const [playerOpen, setPlayerOpen] = React.useState(false);
  const {
    open: openViConVa,
    handleClose: handleCloseViConVa,
    handleOpen: handleOpenViConVa,
  } = useOpen();

  React.useEffect(() => {
    if (!continuoModal) {
      setContinuoModal(false);
      handleOpenViConVa();
    }
  }, [continuoModal]);

  const handleShowModal = () => {
    setShowModal(true);
    setContinuoModal(true);
  };

  const handleCloseModal = () => {
    handleCloseViConVa();
    setShowModal(false);
    setContinuoModal(false);
  };

  const handleVideoSaved = (key: string) => {
    setEmptyInternalVideo(key);
  };

  const clearVideo = async () => {
    await removeImageBlob(emptyInternalVideo);
    setEmptyInternalVideo("");
    setPlayerOpen(false);
  };

  const openPlayer = () => {
    setPlayerOpen(true);
  };

  const closePlayer = () => {
    setPlayerOpen(false);
  };

  const handleUpload = async () => {
    if (!emptyInternalVideo) {
      message.error("No se ha seleccionado ningún video.");
      return;
    }

    const getVideo = await getImageBlob(emptyInternalVideo);
    // const videoBlob = base64ToBlob(recordedVideoBase64);

    const formData = new FormData();
    formData.append("video", getVideo!, "video.mp4");
    formData.append("type", "videoContenedorVacio");
    formData.append("containerType", "empty");
    formData.append("container", container);

    try {
      setLoading(true);
      const { data: dataPost } = await workflowContainerVideosPost(formData);
      // message.success("Video subido exitosamente.", 5);
      Swal.fire({
        title: "Video Vacío subido exitosamente",
        icon: "success",
        confirmButtonColor: "#1677ff",
        // imageUrl: result.value.avatar_url
      });
      clearVideo();
    } catch (error: any) {
      message.error(error.toString(), 5);
    } finally {
      setLoading(false);
      // setSelectedVideo(null);
      // setPreviewUrl(null);
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={10}
      md={8}
      lg={6}
      xl={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        // margin: "0px 20px",
      }}
    >
      {emptyInternalVideo ? (
        <Button
          color="green"
          variant="solid"
          onClick={openPlayer}
          size="large"
          style={{
            width: "100%",
            minWidth: "320px",
            maxWidth: "320px",
            fontSize: "1em",
            fontWeight: "bold",
            marginTop: "10px",
          }}
          icon={<PlaySquareOutlined />}
        >
          REPRODUCIR VIDEO
        </Button>
      ) : (
        <Button
          type={!emptyInternalVideo ? "dashed" : "primary"}
          size="large"
          danger={!emptyInternalVideo ? true : false}
          style={{
            width: "100%",
            minWidth: "320px",
            maxWidth: "320px",
            fontSize: "1.1em",
            fontWeight: "bold",
            marginTop: "10px",
          }}
          icon={<VideoCameraAddOutlined />}
          onClick={handleShowModal}
        >
          GRABAR CONTENEDOR VACIO
        </Button>
      )}
      {showModal ? (
        <VideoRecorderNative
          open={openViConVa}
          handleClose={handleCloseModal}
          onVideoSaved={handleVideoSaved}
        />
      ) : null}

      <VideoPlayerModal
        videoKey={emptyInternalVideo}
        open={playerOpen}
        onClose={closePlayer}
        onClear={clearVideo}
      />
      {emptyInternalVideo && (
        <div
          style={{
            marginTop: "10px",
            minWidth: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Popconfirm
            title="Si lo guarda no podrá editar el video"
            description="Desea Continuar?"
            onConfirm={handleUpload}
            zIndex={1601}
            okText="Si"
            cancelText="No"
          >
            <Button
              type="primary"
              size="large"
              icon={<SaveOutlined />}
              loading={loading}
              style={{ marginRight: "10px", fontSize: "1.1em" }}
              disabled={!container}
            >
              GUARDAR
            </Button>
          </Popconfirm>
          <Button
            type="dashed"
            size="large"
            icon={<ClearOutlined />}
            onClick={clearVideo}
            style={{ fontSize: "1.1em" }}
          >
            LIMPIAR
          </Button>
        </div>
      )}
    </Grid>
  );
};

export default VideoPageComponent;
